import React, { useState } from 'react';
import { Link } from 'react-router-dom';


// txHash, receiverWalletAddress



const SignupForm = ({ registerData, setRegisterData, handleSubmit }) => {

    const [isShow, setIsShow] = useState({
        password: false,
        tpassword: false,
    });

    const handleCopyToClipboard = (e) => {
        const text = e.target.innerText;
        navigator.clipboard.writeText(text);
    }

    const handleChange = (e) => {
        const { value, name } = e.target;

        setRegisterData((prev) => ({ ...prev, [name]: value }));
    }

    const handleGenerateUsername = (e) => {
        const value = e.target.value;

        if (value === "" || value === undefined || value === null) return;

        let key = value.substring(0, 4);
        const pattern = "123456789ABCDEFGHIJKLMNPQRSTUVWXYZ";

        const length = value.length >= 4 ? 5 : (4 - value.length) + 5;

        for (let i = 0; i < length; i++) {
            key += pattern[Math.floor(Math.random() * 34)];
        }

        setRegisterData((prev) => ({ ...prev, ["username"]: key }));
        // console.log(key);
    }

    const handleCheckAmt = (e) => {
        const { value, name } = e.target;

        if (value < 5) {
            alert("Minimum Investment is 5 USDT");
            setRegisterData((prev) => ({...prev, [name]: ""}))
            return;
        }
    }

    return (
        <form class="login mt-2" id="signup"
            onSubmit={(e) => handleSubmit(e)}
        >
            <input type="hidden" name="action" value="signup" />
            <input type="text" class="form-control login-field" id="txtFName" placeholder="User Name" name="fullname"
                value={registerData?.fullname} required
                onChange={(e) => handleChange(e)}
                onBlur={handleGenerateUsername}
            />

            <div className={`${!registerData?.username ? "mt-4" : "mt-1"}`}>
                {registerData?.username &&
                    <p class="tagline mt-2" style={{ fontSize: ".95rem" }}
                    // onClick={handleCopyToClipboard}
                    > {registerData.username} </p>
                }
            </div>

            <input type="text" class="form-control login-field mt-0" id="txtLName"
                placeholder="Referral Code" name="referral_code"
                value={registerData?.referral_code} required
                onChange={(e) => handleChange(e)}
            />

            <div
                className='w-100 position-relative'
            >
                <input type={isShow.password ? "text" : "password"} class="form-control login-field mt-4" id="txtPassword"
                    name="password" placeholder="Secure Pin"
                    value={registerData?.password} required
                    onChange={(e) => handleChange(e)}
                />

                <div className='password-toggle-btn'
                    // style={{ position: "absolute", right: "1rem", top: "50%", padding: ".2rem .4rem", zIndex: 9999 }}
                    onClick={() => setIsShow((prev) => ({ ...prev, ["password"]: !prev.password }))}
                >
                    <img src={isShow.password ?
                        require("../assets/icon/hide_password.svg").default
                        :
                        require("../assets/icon/show_password.svg").default
                    }
                    />
                </div>
            </div>
            

            {/* <div
                className='w-100 position-relative'
            >
                <input type={isShow.tpassword ? "text" : "password"} class="form-control login-field mt-4" id="txtCPassword"
                    name="tpassword" placeholder="Transaction Pin"
                    value={registerData?.tpassword} required
                    onChange={(e) => handleChange(e)}
                />

                <div className='password-toggle-btn'
                    // style={{ position: "absolute", right: "1rem", top: "50%", padding: ".2rem .4rem", zIndex: 9999 }}
                    onClick={() => setIsShow((prev) => ({ ...prev, ["tpassword"]: !prev.tpassword }))}
                >
                    <img src={isShow.tpassword ?
                        require("../assets/icon/hide_password.svg").default
                        :
                        require("../assets/icon/show_password.svg").default
                    }
                    />
                </div>
            </div> */}

            <div
                className='w-100 position-relative'
            >
                <input type={isShow.trxn_pass ? "text" : "password"} class="form-control login-field mt-4" id="txtCPassword"
                    name="trxn_pass" placeholder="Transaction Pin"
                    value={registerData?.trxn_pass} required
                    onChange={(e) => handleChange(e)}
                />

                <div className='password-toggle-btn'
                    // style={{ position: "absolute", right: "1rem", top: "50%", padding: ".2rem .4rem", zIndex: 9999 }}
                    onClick={() => setIsShow((prev) => ({ ...prev, ["trxn_pass"]: !prev.trxn_pass }))}
                >
                    <img src={isShow.trxn_pass ?
                        require("../assets/icon/hide_password.svg").default
                        :
                        require("../assets/icon/show_password.svg").default
                    }
                    />
                </div>
            </div>

            {/* <input type="text" class="form-control login-field mt-4" id="txtAmount"
                placeholder="Amount" name="amount"
                value={registerData?.amount} required
                onChange={(e) => handleChange(e)}
                // onBlur={(e) => handleCheckAmt(e)}
            /> */}

            <span class="form-field-notification" id='cusVerify'></span>

            <div class="my-3 w-100 d-flex">
                {/* <div class="me-2" style={{ fontSize: '13px' }}>
                                        <input class="form-check-input ms-1" type="checkbox" id="tandc" name="tandc" required />
                                        By continuing, you agree to our <Link to="/parivacy">Privacy Policy</Link> and <Link to="/termas" style={{ textDecoration: 'underline' }}>T&amp;C</Link>
                                    </div> */}
            </div>

            {/* div to show reCAPTCHA  */}
            <div class="g-recaptcha" data-sitekey=""></div>
            <button className="btn w-100 sign-in-btn g-recaptcha"
            // onClick={depositUSDT}
            >
                Sign up
            </button>


            <div class="signup-text mt-4">Already Participated? <Link to="/signin">Sign in</Link></div>
        </form>
    )
}

export default SignupForm;